/**
 * clsx-like class join for revive-landing only (no clsx/tailwind-merge dependency).
 * Does not merge conflicting Tailwind utilities; callers should avoid duplicate keys.
 */
export function cn(...inputs) {
  const out = [];
  const walk = (v) => {
    if (v == null || v === false || v === "") return;
    const t = typeof v;
    if (t === "string" || t === "number") {
      const s = String(v).trim();
      if (s) out.push(s);
      return;
    }
    if (Array.isArray(v)) {
      v.forEach(walk);
      return;
    }
    if (t === "object") {
      for (const [key, ok] of Object.entries(v)) {
        if (ok) walk(key);
      }
    }
  };
  inputs.forEach(walk);
  return out.join(" ");
}

export function formatUsd(value) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: value > 100 ? 0 : 2,
  }).format(value);
}

/** Token USD price: standard formatting from $1+, up to 9 fraction digits below. */
export function formatUsdPrice(value) {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return "—";
  if (n >= 1) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: n >= 100 ? 0 : 2,
    }).format(n);
  }
  const s = n.toFixed(9).replace(/\.?0+$/, "");
  return `$${s}`;
}

/** Compact USD for feed stats: $1.23K, $2.45M, $1.10B */
export function formatUsdCompact(value) {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return "$0";
  const compact = (amount, suffix) => `$${amount.toFixed(2)}${suffix}`;
  if (n >= 1_000_000_000) return compact(n / 1_000_000_000, "B");
  if (n >= 1_000_000) return compact(n / 1_000_000, "M");
  if (n >= 1_000) return compact(n / 1_000, "K");
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: n >= 1 ? 0 : 2,
  }).format(n);
}

export function timeAgo(isoDate) {
  const then = new Date(isoDate).getTime();
  const now = Date.now();
  const diff = Math.max(1, Math.floor((now - then) / 1000));
  if (diff < 60) return `${diff}s ago`;
  const mins = Math.floor(diff / 60);
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.floor(hours / 24)}d ago`;
}
